import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Tabs from '../../Components/Tabs';
import Oders from '../../Components/MyAccountTabs/Oders';

const MyOders = () => {

    useEffect(() => {
        document.title = 'StoneSkill | My Orders'
    })
    return (
        <main className="main pages">
            <div className="page-header breadcrumb-wrap">
                <div className="container">
                    <div className="breadcrumb">
                        <Link to="/" rel="nofollow"><i className="fi-rs-home mr-5" />Home</Link>
                        <span /> Pages <span /> My Oders
                    </div>
                </div>
            </div>
            <div className="page-content pt-30 pb-30">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 m-auto">
                            <div className="row">
                                <div className="col-md-3">
                                    <Tabs />
                                </div>
                                <div className="col-md-9">
                                    <div className="tab-content account dashboard-content pl-50">
                                        <div className="tab-pane fade active show" id="dashboard" role="tabpanel" aria-labelledby="dashboard-tab">
                                            <Oders />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default MyOders